export const NONE_CHOOSEN = 'NoneChosen';

const getDateParts = (value) => value.split('-');

const gtmEvent = (event, data = {}) => ({ event, ...data });

const gtmSearchEvent = (data = {}) => gtmEvent('Search', {
  travelAction: 'Search',
  ...data,
});

const gtmFilterEvent = (data = {}) => gtmEvent('Filter', {
  travelAction: 'Filter',
  travelFilterSet: 'LMS List',
  ...data,
});

export const getGTMSortOrderEvent = (orderBy) => {
  const logValue = {
    DATE: 'D',
    PRICE: 'LP',
  };

  return gtmEvent('Sort order', { sortOrder: logValue[orderBy] });
};

export const getGTMFilterButtonEvent = () => gtmEvent('Filter button');

export const getGTMFilterDestinationEvent = (code, isCountry) => {
  return gtmFilterEvent({
    travelFilterCategory: isCountry ? 'Country' : 'Destination',
    travelFilterValue: code,
  });
};

// when user clicks the clear filter button in the filter panel
export const getGTMClearFilterEvent = () => gtmEvent('Clear filter');
// when user clicks the show x trips button in the filter panel
export const getGTMShowFilteredEvent = () => gtmEvent('Show filtered trips');

// User changes trip type
export const getGTMFilterTripTypeEvent = (code, tripTypes) => {
  const current = tripTypes.find((tt) => tt.key === code);

  if (current) {
    return gtmFilterEvent({
      travelFilterCategory: 'Travel Type',
      travelFilterValue: current.gtm?.value,
    });
  }

  return null;
};

export const getGTMFilterPriceEvent = (price) => {
  return gtmFilterEvent({
    travelPrice: price,
    travelFilterCategory: 'Price',
    travelFilterValue: 'Price',
  });
};

// When user changes departure airports
export const getGTMFilterDepartureEvent = (selected) => {
  return gtmSearchEvent({
    travelDepartureCode: selected.join(','),
  });
};

// When user changes trip length
export const getGTMFilterTripLengthEvent = (selected) => {
  return gtmSearchEvent({
    ...(selected?.gtm || {}),
  });
};

// When user changes from date
export const getGTMFilterDateFromEvent = (selected) => {
  const [year, month, day] = getDateParts(selected);

  return gtmSearchEvent({
    travelDepartureYear: year,
    travelDepartureMonth: month,
    travelDepartureDay: day,
  });
};

export const getGTMFilterDateToEvent = () => {
  return gtmSearchEvent({});
};

// when users clicks on show more
export const getGTMShowMoreEvent = () => gtmEvent('Show more trips');
